import FORM_BUILDER from 'ui-blocks/form-builder/constants';
import {
   sponsoredAdsAdvertiserTrafficRuleCreate,
   sponsoredAdsAdvertiserTrafficRuleUpdate,
   sponsoredAdsAdvertiserTrafficRuleGet,
} from '../../../services/servicesSponsoredAds';

const formBuilderConfig = {
   defaultInitialValues: {
      type: {
         label: 'Blacklist',
         value: 'advertiser_blacklist',
      },
      device: {
         label: 'All Devices',
         value: '',
      },
      status: false,
      advertisers: [],
      campaigns: [],
      publishers: [],
      sources: [],
      contracts: [],
   },
   settings: {
      type: FORM_BUILDER.TYPE.EDIT_ADD,
      internal: {
         routing: {
            basePath: '/sponsored-ads/traffic-rules/advertiser-rules',
         },
      },
      external: {
         api: {
            get: sponsoredAdsAdvertiserTrafficRuleGet,
            save: {
               create: sponsoredAdsAdvertiserTrafficRuleCreate,
               edit: sponsoredAdsAdvertiserTrafficRuleUpdate,
            },
            // getInitialValues:       -- value is a promise
            // save :                  -- has two value variations to take into consideration for the (1) Case: theres one API for
            //                            create & edit and for the (2) Case: where theres two separate APIs for 'create' and 'edit'
            //          E.g., Save Variation Value #1 -- value is a promise
            //          E.g., Save Variation Value #2 -- value is an object with the shape
            //                {
            //                   edit,       // -- value is a promise
            //                   create,     // -- value is a promise
            //                }
            responseMiddleware: {
               get: (resData) => {
                  const initialValues = { ...resData };
                  initialValues.sources = resData.sources?.map((source, id) => (
                     { name: source, id }
                  ));
                  initialValues.device = resData.device || '';
                  initialValues.status = resData?.status === 'Y';
                  return initialValues;
               },
            },
         },
      },
   },
};

export default formBuilderConfig;
